import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { track } from '@/utils/analytics';
import BaseAction from './base.action';
import { ActionName, ActionTitle } from '../enums';

export default class EditSecondaryAction extends BaseAction {
  name = ActionName.EditIcon;
  title = null;
  colorScheme = StyleColorSchemeType.White;

  #analyticEvent = null;

  constructor(config = {}) {
    super(config);
    this.#analyticEvent = config.analyticEvent;
    this.title = config.title || ActionTitle.EditListing;
  }

  execute(listing) {
    this.#trackExecution(listing);

    this.propagateResult(listing, true);
  }

  #trackExecution({ listingId }) {
    track(this.#analyticEvent, {
      listingId,
    });
  }
}
